import { useWorkspaceQuery } from "@/hooks/use-workspace-query";
import { api } from "convex/_generated/api";

/**
 * Returns true when the workspace uses BYOK (Bring Your Own Key) — i.e.
 * provider === "byom_openai_compatible". Returns undefined while loading.
 */
export function useIsByok(): boolean | undefined {
  const { data: config } = useWorkspaceQuery(api.workspace_ai_provider.get, {});
  if (config === undefined) return undefined;
  return config?.provider === "byom_openai_compatible";
}
